export function MrnLookupStep({
  mrn,
  busy,
  disabled,
  onMrnChange,
  onCheck,
  onClear,
}: {
  mrn: string;
  busy: boolean;
  disabled: boolean;
  onMrnChange: (value: string) => void;
  onCheck: () => void;
  onClear: () => void;
}) {
  return (
    <div className="offer-mrn-lookup-step">
      <label className="offer-campaign-field">
        <span>Patient MRN</span>
        <input value={mrn} onChange={event => onMrnChange(event.target.value.toUpperCase())} placeholder="Enter patient MRN" disabled={busy} />
      </label>
      <div className="offer-campaign-actions">
        <button className="btn btn-primary" type="button" onClick={onCheck} disabled={disabled || busy}>{busy ? 'Checking...' : 'Check Eligibility'}</button>
        <button className="btn btn-outline" type="button" onClick={onClear}>Clear</button>
      </div>
    </div>
  );
}
